<template>
  <nav class="navbar navbar-expand-md navbar-light">
    <div class="container">
    <div class="ml-3 nav-item mr-auto">
      <router-link to="./"><span><b>BotAmp</b></span></router-link>
    </div>

    <div class="nav-item mr-3">
      <router-link to="./faq"><span>FAQ</span></router-link>
    </div>

    <div class="nav-item mr-3">
      <a href="https://botometer.osome.iu.edu/"><span>Botometer</span></a>
    </div>

    <div class="nav-item mr-3">
      <a href="https://osome.iu.edu/" target="_blank"><span>OSoMe</span></a>
    </div>

    <b-dropdown class="nav-item" variant="link" size="md" no-caret aria-label="Profile options">
    <template slot="button-content"><img :src="$parent.profile.image"><span class="profile-name" style="color: white" v-text="this.$parent.profile.name"></span><span class="visually-hidden">Profile options</span>
    </template>

    <b-dropdown-item v-if="!this.$parent.twitter_account_info.name" class="dropdown-item" @click.prevent.stop="$parent.twitterLogIn()"><span style="color: black">Log In</span></b-dropdown-item>
    <b-dropdown-item v-if="this.$parent.twitter_account_info.name" class="dropdown-item" @click.prevent.stop="$parent.twitterLogOut()"><span style="color: black">Log Out</span></b-dropdown-item>
    </b-dropdown>
    </div>
  </nav>

</template>

<script>
export default {
  name: 'Navbar'
}
</script>

<style scoped>

span {
  color: #fff;
  font-size: 20px;
  vertical-align: middle;
}

a:hover {
  text-decoration: none;
}

img {
  height: 40px;
  vertical-align: middle;
}

.navbar {
  background-color: rgb(153, 0, 0);
}

.nav-item {
  color: #fff
}

.nav-item:hover {
  color: #E1D8B7;
  cursor: pointer;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0,0,0,0);
  border: 0;
}

</style>
